import { api } from "@healthos/schemas";
/**
 * The prompt for a member who has not joined, or null when there is nothing to
 * ask: no active challenge, or they already joined under current wording.
 */
export function companyChallengeJoinPrompt(challenge) {
    if (!challenge)
        return null;
    const agreed = challenge.viewerJoined &&
        challenge.viewerConsentVersion === api.WALKING_CHALLENGE_CONSENT_VERSION;
    if (agreed)
        return null;
    const reAsking = challenge.viewerJoined;
    return {
        challengeName: challenge.name,
        route: challenge.route,
        title: reAsking ? "One thing has changed" : challenge.name,
        body: reAsking
            ? "How company standings work has changed since you joined. Have another look before you stay in."
            : challenge.description,
        gains: [
            `Your steps move you along ${challenge.route.name}`,
            "You appear on the shared route and company standings",
            "Your walking groups can be ranked together",
        ],
        reassurance: "Stay out and your everyday movement stays private. You can explore the route before you decide.",
        targetSteps: challenge.targetSteps,
        participantCount: challenge.participantCount,
        endsOnLabel: shortDate(challenge.endsOn),
        consentVersion: api.WALKING_CHALLENGE_CONSENT_VERSION,
    };
}
/** "2026-08-31" as "31 Aug". Falls back to the raw value if it will not parse. */
function shortDate(calendarDate) {
    const parsed = new Date(`${calendarDate}T00:00:00`);
    if (Number.isNaN(parsed.getTime()))
        return calendarDate;
    return parsed.toLocaleDateString(undefined, { day: "numeric", month: "short" });
}
//# sourceMappingURL=company-challenge-join.js.map